// extracted by mini-css-extract-plugin
export default {"section":"Merch_section__BC7Zt","tShirt_holder":"Merch_tShirt_holder__PUpPJ","hoodie_holder":"Merch_hoodie_holder__Bh80Z","merchImg":"Merch_merchImg__e8fyP"};